// see https://learn.microsoft.com/de-de/azure/active-directory/develop/tutorial-v2-angular-auth-code

import {Route, RouterModule, Routes} from "@angular/router";
import {authGuard} from "../../../../features/auth/auth/auth.guard";
import {NgModule} from "@angular/core";
import {HomePagePage} from "../../../../features/core/shared/home-page/home-page.page";
import {AppMainComponent} from "./app.main.component";

export function getMvsaRouters() : {name: string, routeMethod: () => Routes}[] {
    const modules : {name: string, routeMethod: () => Routes}[] =
        [
        ];

    return modules;

}


function collectSubRoutes(): Route[] {
    let routes : Route[] =     [

        {path: '', component: HomePagePage},
    ];

    // collect all routes
    const mvsaRouters = getMvsaRouters();

    if (mvsaRouters) {
        for (let mvsaRouter of mvsaRouters) {

            const subRoutes = mvsaRouter.routeMethod();

            if (subRoutes) {
                for (let subRoute of subRoutes) {

                    // add guard
                    if (subRoute.canActivate) {
                        subRoute.canActivate.push(authGuard);
                    } else {
                        subRoute.canActivate = [authGuard];
                    }


                    routes.push(subRoute);
                }
            }

        }
    }

    // import {AdSubRoutes} from "./ad/ad.route";


    return routes;

}



const routes: Routes =
    [
        {
            path: '', component: AppMainComponent,
            children: [
                ...collectSubRoutes(),
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-crm/feature-crm.routing.module')
                            .then(m => m.FeatureCrmRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-core/feature-core.routing.module')
                            .then(m => m.FeatureCoreRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-bm/feature-bm.routing.module')
                            .then(m => m.FeatureBmRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-integration/feature-integration.routing.module')
                            .then(m => m.FeatureIntegrationRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/core/core.routing.module')
                            .then(m => m.CoreRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-planning/feature-planning.routing.module')
                            .then(m => m.FeaturePlanningRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-power/feature-power.routing.module')
                            .then(m => m.FeaturePowerRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-auth/feature-auth.routing.module')
                            .then(m => m.FeatureAuthRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-misc/feature-misc.routing.module')
                            .then(m => m.FeatureMiscRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-prov/feature-prov.routing.module')
                            .then(m => m.FeatureProvRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-tech/feature-tech.routing.module')
                            .then(m => m.FeatureTechRoutingModule)
                },
                {
                    path: '',
                    loadChildren: () =>
                        import('../../../../features/feature-launchpad/feature-launchpad.routing.module')
                            .then(m => m.FeatureLaunchpadRoutingModule)
                }
            ]
        },
        {path: '**', redirectTo: '/notfound'},
    ];

const isIframe = window !== window.parent && !window.opener;


@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            {
                scrollPositionRestoration: 'disabled',
                // Don't perform initial navigation in iframes or popups
                // initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
            }
            )
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {


}
